import { useEffect, useRef } from "react";
import { useToast } from "@/shared/ui";

/** Quote failures use the shared popup without expanding the tool form. */
export function ImageToolQuoteError({ error, onRetry }: { error: Error; onRetry: () => void }) {
  const { toast } = useToast();
  const retry = useRef(onRetry);
  retry.current = onRetry;
  useEffect(() => {
    toast("The price couldn’t be calculated for this image.", { tone: "danger", actionLabel: "Retry", onAction: () => retry.current() });
  }, [error, toast]);
  return null;
}
